<template>
  <div>
    <el-table
      :row-class-name="tableRowClassName"

      :show-header="false"
      :data="detailData" class="table">
      <el-table-column
        prop="name"
        label="Date"
        width="200"
      >
      </el-table-column>
      <el-table-column
        prop="value"
        label="Name"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.name !== 'Creator'">{{scope.row.value}}</span>
          <router-link v-else :to="'/address/'+ scope.row.value + '/tx/1'">{{scope.row.value}}</router-link>
        </template>
      </el-table-column>
    </el-table>
  </div>

</template>

<script>
  export default {
    props: ['detailData'],
    name: 'TableDetail',
    methods: {
      tableRowClassName({ row, rowIndex }) {
        return rowIndex & 1 ? 'odd-row' : 'bdd-row';
      },
    }
  }
  ;
</script>

<style scoped lang="scss">
  .table {
    margin-top: 60px;
    margin-right: 30px;
  }
</style>
